import { useUserStoreDefinition } from '~/store/user';

export default function ({ redirect, app }) {
  const userStore = useUserStoreDefinition(app.pinia);
  if (process.client && !userStore.canListUsers) {
    return redirect('/');
  }
}
